import InvitesList from "./invites-list";

export default InvitesList;
